import React from "react";

export const ListIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
            <g clipPath="url(#clip0_188_2414)">
                <rect x="2.1" y="1.1" width="4.8" height="4.8" stroke="#604448" strokeWidth="1.2"/>
                <rect x="2.1" y="8.1" width="4.8" height="4.8" stroke="#604448" strokeWidth="1.2"/>
                <rect x="9.1" y="1.1" width="4.8" height="4.8" stroke="#604448" strokeWidth="1.2"/>
                <rect x="9.1" y="8.1" width="4.8" height="4.8" stroke="#604448" strokeWidth="1.2"/>
            </g>
            <defs>
                <clipPath id="clip0_188_2414">
                    <rect width="16" height="13" fill="white" transform="translate(16 13.5) rotate(180)"/>
                </clipPath>
            </defs>
        </svg>
    )
}
